import { AxiosInstance } from "axios";
import { getBoardApiUrl } from "helpers";
import { BoardMembershipModel } from "models/BoardMembershipModel";
import { SiveActionResult } from "models/SiveActionResult";
import { UserModel } from "models/UserModel";

export class BoardMembersApi {
  constructor(private axios: AxiosInstance) {}

  async getItems(): Promise<UserModel[]> {
    const url = getBoardApiUrl(`members`);
    const response = await this.axios.get<UserModel[]>(url);
    return response.data;
  }

  async find(filter: string): Promise<UserModel[]> {
    const url = getBoardApiUrl(`members/find/${filter}`);
    const response = await this.axios.get<UserModel[]>(url);
    return response.data;
  }

  async addGroupMember(boardId: string | number, roleName: string, user: string): Promise<SiveActionResult> {
    const response = await this.axios.patch<SiveActionResult>(`api/boards/${boardId}/groups/${roleName}/${user}`);
    return response.data;
  }

  async getGroupMembers(boardId: string | number, roleName: string): Promise<BoardMembershipModel[]> {
    const response = await this.axios.get<BoardMembershipModel[]>(`api/boards/${boardId}/groups/${roleName}`);
    return response.data;
  }

  async removeGroupMember(boardId: string | number, roleName: string, user: string): Promise<SiveActionResult> {
    const response = await this.axios.delete<SiveActionResult>(`api/boards/${boardId}/groups/${roleName}/${user}`);
    return response.data;
  }
}
